export default "__VITE_ASSET__BePIScCk__"